// extracted by mini-css-extract-plugin
export default {"wrapper":"Marquee_wrapper__evyPv","inner":"Marquee_inner__RCoO2","marqueeScroll":"Marquee_marqueeScroll__sFWgV"};